import { Component, Input } from '@angular/core';
import { PasswordValidationStatusResponse } from 'src/app/utils/cargo-driver-check-in-service/services/auth.service';

@Component({
  selector: 'app-password-validation-issues',
  templateUrl: './password-validation-issues.component.html',
  styleUrl: './password-validation-issues.component.scss',
  standalone: true
})
export class PasswordValidationIssuesComponent {
  @Input() passwordValidationResponse: PasswordValidationStatusResponse;
}
